import { c as _c } from "react/compiler-runtime";
import { showChat } from '../../../utils/liveChat';
import Link from '../base/Link';
import Text from '../base/Text';
const MetricError = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      t: 1,
      x: 4
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Text p={t0} muted={true} center={true}>We weren’t able to find any data due to an error, please try again later or{" "}<Link as="button" primary={true} onClick={showChat}>contact us.</Link></Text>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default MetricError;